import HIKVideoLossModal from './HIK_video_loss-modal.vue'
export default HIKVideoLossModal
